module.exports = __webpack_public_path__ + "0c386c53aa161b37a849ec77041ed058.png";